module.exports = __webpack_public_path__ + "img/Shawarma_Meal_Falafel.0c15cd21.jpg";